import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'


Vue.use(Router)

export default new Router({
  routes: [
    {path: '/', name: 'HelloWorld', component: HelloWorld,children:[

    ]},
    {path: '/login', name: 'Login', component: Login},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js